<template>

  <div class="vflex">
    <div class="vflex-row-0 pt-3">
      <ul class="nav nav-tabs">
        <li class="nav-item pl-3">
          <router-link
            class="nav-link"
            :class="{active: currentRoute === '/config/member'}"
            to="/config/member">{{ $t('Members') }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: currentRoute === '/config/member/invite'}"
            to="/config/member/invite">{{ $t('Invitations') }} ({{ paginateInvite.total }})</router-link>
        </li>
      </ul>
    </div>
    <div class="vflex-row-1">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Member',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    currentRoute () {
      return this.$route.path
    },
    paginateInvite () {
      return this.$store.getters.getMemberInvitesPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      return this.$store.dispatch('selectMemberInvites', {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Member/Member.vue